import { Dispatch, ReactElement, SetStateAction, useState, VFC } from "react";
import { getAmazonList, useInit } from "./logic"
import Card from '@material-ui/core/Card';
import InfiniteScroll from "react-infinite-scroll-component";
import Modal from '@material-ui/core/Modal';
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";

function Page(): ReactElement {
    const { classes, books, setBooks, lastVisible, setLastVisible, setHasMore, hasMore } = useInit();
    const [open, setOpen] = useState(true);


    return (
        <InfiniteScroll dataLength={books.length} next={() => getAmazonList(lastVisible, setLastVisible, setBooks, setHasMore, 'InfiniteScroll')} hasMore={hasMore} loader={<h4>Loading...</h4>}>
            {
                open ? (<CheckModal open={open} setOpen={setOpen}/>) : null 
            }
            <Button style={{display:"block", width:"100px", marginRight:"25px", margin: '5px auto 0 auto'}} variant="contained" size="small" color="primary" onClick={()=>getAmazonList(lastVisible, setLastVisible, setBooks, setHasMore, 'Next')}>Next</Button>
            <div className={classes.cardInfoErea}>
                {books?.map((book, index) => (
                    <Card className={classes.card} key={index + book.isbn10}>
                        <iframe className={classes.img} src={book.image_url} title={book.title}/>
                        <Card>
                            <ul className={classes.cardInfo}>
                                <li><a className={classes.link} href={book.affiliate_url} target="_blank" rel="noreferrer noopener">{index+1}.{book.actress_name}</a></li>
                                <li><a className={classes.title} href={book.affiliate_url} target="_blank" rel="noreferrer noopener">{book.title}</a></li>
                                <li>average : {book.review_average}</li>
                                <li>count : {book.review_count}</li>
                            </ul>
                        </Card>
                    </Card>
                ))}
            </div>
        </InfiniteScroll>
    )
}

function parent() {
    return (
        <Page />
    )
}

export default parent;


type Props ={
    open : boolean
    setOpen : Dispatch<SetStateAction<boolean>>
}

export const CheckModal:VFC<Props> = (props) => {
    const {open , setOpen} = props
    const handleClose = () => {
        setOpen(false);
    };
    const navigate = useNavigate()

    return (
        <Modal open={open} onClose={handleClose} style={{backgroundColor: "black", opacity:"0.9", height:"100vh", width:"100%", display:"grid", textAlign:"center"}}>
            <Card style={{backgroundColor:"whiete", opacity:"1.0", width:"400px", height:"200px" ,margin:"0 auto", display:"grid"}}>
                <p>年齢確認 : 18歳以上ですか？</p>
                <div>
                    <Button style={{width:"100px", marginRight:"25px"}} variant="contained" size="small" color="primary" onClick={()=>handleClose()}>YES</Button>
                    <Button style={{width:"100px", marginLeft:"25px"}} variant="contained" size="small" color="primary" onClick={()=>navigate('/boys')}>NO</Button>
                </div>
            </Card>
        </Modal>
    )
}
